// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../../shared/components/labeled-criteria';

const ClaimHistoryWorkOrderCriteria = props =>
    <div className='claim-history-work-order-criteria'>
        <LabeledCriteria
            className='work-order-criteria'
            isRequired={false}
            label={props.label}
            maxLength='17'
            onInputChange={props.handleInputChange}
            placeholder={props.placeHolderText}
            type='text'
            value={props.value}
        />
    </div>;

ClaimHistoryWorkOrderCriteria.displayName = 'ClaimHistoryWorkOrderCriteria';
ClaimHistoryWorkOrderCriteria.propTypes = {
    handleInputChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    placeHolderText: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};

export default ClaimHistoryWorkOrderCriteria;




// WEBPACK FOOTER //
// ./src/reports/claim-history/components/claim-history-report-criteria/work-order-criteria.js